// Russia
export const locale = {
  TRANSLATOR: {
    SELECT: "Select your language"
  },
  dashboard: {
    analytics_title: "Аналитика по пациентам",
    download_count_title: "Количество установок за все время по играх",
    total_users: "Всего пользователей",
    total_profit: "Общая прибыль",
    profit: "Прибыль",
    profit_popover: "Прибыль за все активные игры активных пользователей",
    number_of_users: "Активных пользователей",
    price_per_game: "Цена за игру",
    active: "Активные",
    not_active: "Не активные",
    downloads: "Загрузки",
    home_page: "Главная",
    edit_price: "Редактировать цену за игру",
    enter_price: "Введите цену",
    max_length: "Максимальная длина",
    cancel: "Отмена",
    save: "Сохранить",
    total: "Всего"
  },
  faq: {
    faq_page: "FAQ",
    title: "Часто задаваемые вопросы",
    contact_us: "Напишите нам"
  },
  instruction: {
    instruction_page: "Инструкция",
    title: "Инструкции",
    contact_us: "Напишите нам",
    how_send: "Как отправлять сообщения",
    presentation: "Презентация ОКОЛО"
  },
  notifications: {
    notifications_page: "Рассылка сообщений",
    sending_messages: "Рассылка сообщений",
    specify_recipients: "Укажите получателей сообщений",
    which_game: "В какую игру отправлять?",
    who_should: "Кому отправлять?",
    all_patients: "Всем пациентам",
    everyone_active_game: "Всем с активной игрой",
    anyone_inactive_game: "Всем с неактивной игрой",
    specify_from_list: "Указать из списка",
    use_post_template: "Использовать шаблон сообщения",
    new: "Новый",
    template_1: "Шаблон  1",
    template_2: "Шаблон  2",
    template_3: "Шаблон  3",
    name: "Название",
    enter_name: "Введите заголовок уведомления",
    max_length: "Максимальная длина",
    message: "Сообщение",
    enter_text: "Введите текст уведомления",
    send: "Отправить уведомление",
    save_template: "Сохранить шаблон",
    last_active: "Последний активный",
    want_send: "Вы уверены, что хотите отправить это сообщение пациентам?",
    sent: "Отправлено",
    sent_message: "Сообщение было успешно отправлено выбранным пациентам",
    of_course: "Да",
    not_sent: "Сообщение не отправлено",
    list_empty:
      "Список получателей пуст. Выберите получателей вручную или измените настройки фильтра.",
    error: "Ошибка",
    contact_admin: "Обратитесь к администратору или повторите попытку позже.",
    cancel: "Отмена"
  },
  login: {
    welcome: "Добро пожаловать в OKOLO",
    pass: "Пароль",
    forgot: "Забыли пароль?",
    login: "Войти",
    enter_email_for_reset:
      "Введите Ваш электронный адрес, чтобы сбросить пароль",
    reset_pass: "Сбросить пароль",
    back: "Назад",
    about_us: "О нас",
    contact_us: "Связаться с нами",
    enter_email: "Введите Email",
    enter_password: "Введите пароль",
    email_not_valid:
      "Значение не является действительным адресом электронной почты.",
    provide_correct_data: "Пожалуйста, введите  правильные данные!"
  },
  header_menu: {
    patients_btn: "Пациенты",
    add_patient: "Добавить пациента",
    email_not_valid:
      "Значение не является действительным адресом электронной почты.",
    enter_password: "Введите пароль",
    min_length: "Минимальная длина",
    max_length: "Максимальная длина",
    last_name: "Фамилия",
    first_name: "Имя",
    phone_number: "Номер телефона",
    comment: "Комментарий",
    pass: "Пароль",
    enter_last_name: "Введите фамилию",
    enter_first_name: "Введите имя",
    enter_phone_number: "Введите номер телефона",
    enter_comment: "Введите комментарий",
    enter_pass: "Введите пароль",
    enter_email: "Введите Email",
    cancel: "Отмена",
    save: "Сохранить",
    for_instance: "Например:",
    doctor_code: "Ваш код врача : "
  },
  footer: {
    news: "Новости"
  },
  topbar: {
    notification_user: "Уведомления пользователя"
  },
  patients: {
    patients: "Пациенты",
    patients_list: "Список всех Ваших пациентов",
    search_placeholder: "Поиск...",
    patient_page: "Страница пациента",
    active_before: "Было доступно до: ",
    active_until: "Доступно до: ",
    status_th: "СТАТУС",
    access_games_th: "ДОСТУП К ИГРАМ",
    full_name_th: "ФИО",
    contacts_th: "КОНТАКТЫ",
    finance_th: "ФИНАНСЫ",
    comments_th: "КОММЕНТАРИЙ",
    not_active: "Не активный",
    active: "Активный"
  },
  patient: {
    patient: "Пациент",
    delete_patient: "Удалить пациента",
    edit_patient: "Редактировать пациента",
    min_length: "Минимальная длина",
    max_length: "Максимальная длина",
    last_name: "Фамилия",
    first_name: "Имя",
    phone_number: "Номер телефона",
    comment: "Комментарий",
    pass: "Пароль",
    enter_last_name: "Введите фамилию",
    enter_first_name: "Введите имя",
    enter_phone_number: "Введите номер телефона",
    enter_comment: "Введите комментарий",
    cancel: "Отмена",
    save: "Сохранить",
    for_instance: "Например:",
    active_user: "Активный пользователь",
    inactive_user: "Неактивный пользователь",
    total_time: "Общее время",
    in_games_h: "в играх (ч)",
    average_time: "Среднее время",
    deactivate_patient: "Деактивировать пациента",
    activate_patient: "Активировать пациента",
    access: "Доступ",
    yes: "Да",
    no: "Нет",
    game_available_until: "Игра доступна до: ",
    by_levels: "По уровнях",
    by_time: "По времени",
    days: "Дней",
    levels_graph_by_date: "График уровней игры по датам",
    time_m: "Время (м)",
    time: "Время",
    timeline_by_date: "График времени игры по датам",
    date_and_format: 'Дата "мм.дд"',
    want_remove_patient: "Вы уверены, что хотите удалить пациента?",
    deleted: "Удалено",
    patient_deleted: "Запись пациента успешно удалена",
    ok: "Понятно",
    level_in_game: "Уровень пациента в игре",
    playing_time: "Время игры в часах",
    level: "Уровень",
    create_date: "Дата регистрации"
  },
  quick_user: {
    hello: "Здравствуйте",
    doctor: "Доктор:",
    user_profile: "Профиль пользователя",
    code: "Код:",
    exit: "Выход"
  }
};
